import getEventBus from '/src/common/event-bus';

export default getEventBus();
